window.bundleDataC = {
"Caden-boy": {
displayName: "Caden",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Caden Personalized Coloring Experience",
variantId: "49274723565805",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Caden_final_cover.png?v=1771691711",
price: "$14.99",
preorder: true
},
{
title: "Caden Dragon Holographic Sticker",
variantId: "49933780418797",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Caden_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Caden Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Caleb-boy": {
displayName: "Caleb",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Caleb Personalized Coloring Experience",
variantId: "49279559794925",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Caleb_final_cover.png?v=1772243801",
price: "$14.99",
preorder: true
},
{
title: "Caleb Dragon Holographic Sticker",
variantId: "49933778092269",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Caleb_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Caleb Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Caledon-boy": {
displayName: "Caledon",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Caledon Personalized Coloring Experience",
variantId: "49655499063533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Caledon_final_cover.png?v=1773501511",
price: "$14.99",
preorder: true
},
{
title: "Caledon Dragon Holographic Sticker",
variantId: "49933754663149",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Caledon_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Caledon Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Callum-boy": {
displayName: "Callum",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Callum Personalized Coloring Experience",
variantId: "49279559860461",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/callum_final_cover.png?v=1772318759",
price: "$14.99",
preorder: true
},
{
title: "Callum Dragon Holographic Sticker",
variantId: "49933778026733",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Callum_holographic_sticker.png?v=1779378945",
price: "$4.99",
preorder: false
},
{
title: "Callum Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Calvin-boy": {
displayName: "Calvin",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Calvin Personalized Coloring Experience",
variantId: "49339409400045",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/calvin_final_cover.png?v=1772318759",
price: "$14.99",
preorder: true
},
{
title: "Calvin Dragon Holographic Sticker",
variantId: "49933772095725",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Calvin_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Calvin Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Cameron-boy": {
displayName: "Cameron",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Cameron Personalized Coloring Experience",
variantId: "49279559925997",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/cameron_final_cover.png?v=1772318758",
price: "$14.99",
preorder: true
},
{
title: "Cameron Dragon Holographic Sticker",
variantId: "49933777993965",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cameron_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Cameron Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Camila-girl": {
displayName: "Camila",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Camila Personalized Coloring Experience",
variantId: "49279560057069",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Camila_final_cover.png?v=1773719956",
price: "$14.99",
preorder: true
},
{
title: "Camila Unicorn Holographic Sticker",
variantId: "49933777961197",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Camila_holographic_sticker.png?v=1779425515",
price: "$4.99",
preorder: false
},
{
title: "Camila Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Carlos-boy": {
displayName: "Carlos",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Carlos Personalized Coloring Experience",
variantId: "49279560122605",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/carlos_final_cover.png?v=1772318760",
price: "$14.99",
preorder: true
},
{
title: "Carlos Dragon Holographic Sticker",
variantId: "49933777928429",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Carlos_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Carlos Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Carol-girl": {
displayName: "Carol",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Carol Personalized Coloring Experience",
variantId: "49983108022509",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Carolfinalcover.png?v=1779026862",
price: "$14.99",
preorder: true
},
{
title: "Carol Unicorn Holographic Sticker",
variantId: "49983094358253",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Carol_holographic_sticker.png?v=1779425511",
price: "$4.99",
preorder: false
},
{
title: "Carol Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Caroline-girl": {
displayName: "Caroline",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Caroline Personalized Coloring Experience",
variantId: "49929669738733",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Caroline_final_cover.png?v=1775415417",
price: "$14.99",
preorder: true
},
{
title: "Caroline Unicorn Holographic Sticker",
variantId: "49933745750253",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Caroline_holographic_sticker.png?v=1779425511",
price: "$4.99",
preorder: false
},
{
title: "Caroline Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Carson-boy": {
displayName: "Carson",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Carson Personalized Coloring Experience",
variantId: "49279560155373",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Carsonfinalcover.png?v=1771571386",
price: "$14.99",
preorder: true
},
{
title: "Carson Dragon Holographic Sticker",
variantId: "49933777895661",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Carson_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Carson Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Carter-boy": {
displayName: "Carter",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Carter Personalized Coloring Experience",
variantId: "49279560319213",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Carter_final_cover.png?v=1772318759",
price: "$14.99",
preorder: true
},
{
title: "Carter Dragon Holographic Sticker",
variantId: "49933777862893",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Carter_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Carter Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Caspian-boy": {
displayName: "Caspian",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Caspian Personalized Coloring Experience",
variantId: "49731768778989",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Caspian_final_cover.png?v=1774739906",
price: "$14.99",
preorder: true
},
{
title: "Caspian Dragon Holographic Sticker",
variantId: "49933753647341",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Caspian_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Caspian Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Cassian-boy": {
displayName: "Cassian",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Cassian Personalized Coloring Experience",
variantId: "49731870064877",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cassian_final_cover.png?v=1774739906",
price: "$14.99",
preorder: true
},
{
title: "Cassian Dragon Holographic Sticker",
variantId: "49933753516269",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cassian_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Cassian Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Catherine-girl": {
displayName: "Catherine",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Catherine Personalized Coloring Experience",
variantId: "49402711245037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/CATHERINEFINALCOVER.png?v=1771820023",
price: "$14.99",
preorder: true
},
{
title: "Catherine Unicorn Holographic Sticker",
variantId: "49933767999725",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Catherine_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Catherine Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Cecilia-girl": {
displayName: "Cecilia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Cecilia Personalized Coloring Experience",
variantId: "49339325448429",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cecilia_final_cover.png?v=1773766531",
price: "$14.99",
preorder: true
},
{
title: "Cecilia Unicorn Holographic Sticker",
variantId: "49933772456173",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cecilia_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Cecilia Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Celeste-girl": {
displayName: "Celeste",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Celeste Personalized Coloring Experience",
variantId: "49274643415277",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Celeste_final_cover.png?v=1773719956",
price: "$14.99",
preorder: true
},
{
title: "Celeste Unicorn Holographic Sticker",
variantId: "49933780615405",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Celeste_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Celeste Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Cesar-boy": {
displayName: "Cesar",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Cesar Personalized Coloring Experience",
variantId: "49279560450285",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/cesar_final_cover.png?v=1772318760",
price: "$14.99",
preorder: true
},
{
title: "Cesar Dragon Holographic Sticker",
variantId: "49933777830125",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cesar_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Cesar Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Charles-boy": {
displayName: "Charles",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Charles Personalized Coloring Experience",
variantId: "49279560581357",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/charles_final_cover.png?v=1772318759",
price: "$14.99",
preorder: true
},
{
title: "Charles Dragon Holographic Sticker",
variantId: "49933777797357",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Charles_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Charles Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Charlie-boy": {
displayName: "Charlie",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Charlie Personalized Coloring Experience",
variantId: "49279560679661",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Charlie_final_cover.png?v=1771691706",
price: "$14.99",
preorder: true
},
{
title: "Charlie Dragon Holographic Sticker",
variantId: "49933777764589",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Charlie_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Charlie Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Charlotte-girl": {
displayName: "Charlotte",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Charlotte Personalized Coloring Experience",
variantId: "49279560745197",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Charlotte_final_cover.png?v=1773719955",
price: "$14.99",
preorder: true
},
{
title: "Charlotte Unicorn Holographic Sticker",
variantId: "49933777699053",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Charlotte_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Charlotte Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Chase-boy": {
displayName: "Chase",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Chase Personalized Coloring Experience",
variantId: "49279560909037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Chase_final_cover.png?v=1772318759",
price: "$14.99",
preorder: true
},
{
title: "Chase Dragon Holographic Sticker",
variantId: "49933777666285",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Chase_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Chase Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Chloe-girl": {
displayName: "Chloe",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Chloe Personalized Coloring Experience",
variantId: "49279560974573",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Chloe_final_cover.png?v=1773719956",
price: "$14.99",
preorder: true
},
{
title: "Chloe Unicorn Holographic Sticker",
variantId: "49933777633517",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Chloe_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Chloe Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Christian-boy": {
displayName: "Christian",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Christian Personalized Coloring Experience",
variantId: "49343572836589",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/christian_final_cover.png?v=1772318760",
price: "$14.99",
preorder: true
},
{
title: "Christian Dragon Holographic Sticker",
variantId: "49933772062957",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Christian_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Christian Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Christopher-boy": {
displayName: "Christopher",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Christopher Personalized Coloring Experience",
variantId: "49343575359725",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/christopher_final_cover.png?v=1772318758",
price: "$14.99",
preorder: true
},
{
title: "Christopher Dragon Holographic Sticker",
variantId: "49933772030189",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Christopher_holographic_sticker.png?v=1779378942",
price: "$4.99",
preorder: false
},
{
title: "Christopher Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Chrystal-girl": {
displayName: "Chrystal",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Chrystal Personalized Coloring Experience",
variantId: "49929728131309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Chrystal_final_cover.png?v=1775415513",
price: "$14.99",
preorder: true
},
{
title: "Chrystal Unicorn Holographic Sticker",
variantId: "49933745389805",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Chrystal_holographic_sticker.png?v=1779425513",
price: "$4.99",
preorder: false
},
{
title: "Chrystal Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Claire-girl": {
displayName: "Claire",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Claire Personalized Coloring Experience",
variantId: "49279561072877",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Claire_final_cover.png?v=1772851513",
price: "$14.99",
preorder: true
},
{
title: "Claire Unicorn Holographic Sticker",
variantId: "49933777600749",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Claire_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Claire Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Clara-girl": {
displayName: "Clara",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Clara Personalized Coloring Experience",
variantId: "49754308903149",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Clara_final_cover.png?v=1775322361",
price: "$14.99",
preorder: true
},
{
title: "Clara Unicorn Holographic Sticker",
variantId: "49933753155821",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Clara_holographic_sticker.png?v=1779425515",
price: "$4.99",
preorder: false
},
{
title: "Clara Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Cleo-girl": {
displayName: "Cleo",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Cleo Personalized Coloring Experience",
variantId: "49274327302381",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cleo_final_cover.png?v=1773719957",
price: "$14.99",
preorder: true
},
{
title: "Cleo Unicorn Holographic Sticker",
variantId: "49933780812013",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cleo_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Cleo Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Cody-boy": {
displayName: "Cody",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Cody Personalized Coloring Experience",
variantId: "49400127684845",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cody_final_cover.png?v=1771691584",
price: "$14.99",
preorder: true
},
{
title: "Cody Dragon Holographic Sticker",
variantId: "49933769933037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cody_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Cody Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Cole-boy": {
displayName: "Cole",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Cole Personalized Coloring Experience",
variantId: "49343578407149",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/cole_final_cover.png?v=1772318758",
price: "$14.99",
preorder: true
},
{
title: "Cole Dragon Holographic Sticker",
variantId: "49933771997421",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cole_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Cole Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Collin-boy": {
displayName: "Collin",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Collin Personalized Coloring Experience",
variantId: "49400123752685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Collin_final_cover.png?v=1771691585",
price: "$14.99",
preorder: true
},
{
title: "Collin Dragon Holographic Sticker",
variantId: "49933770031341",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Collin_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Collin Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Collins-girl": {
displayName: "Collins",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Collins Personalized Coloring Experience",
variantId: "49754325811437",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Collins_final_cover.png?v=1775322361",
price: "$14.99",
preorder: true
},
{
title: "Collins Unicorn Holographic Sticker",
variantId: "49933753090285",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Collins_holographic_sticker.png?v=1779425515",
price: "$4.99",
preorder: false
},
{
title: "Collins Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Colton-boy": {
displayName: "Colton",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Colton Personalized Coloring Experience",
variantId: "49279561171181",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/colton_final_cover.png?v=1772318759",
price: "$14.99",
preorder: true
},
{
title: "Colton Dragon Holographic Sticker",
variantId: "49933777567981",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Colton_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Colton Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Connor-boy": {
displayName: "Connor",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Connor Personalized Coloring Experience",
variantId: "49343579324653",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/connor_final_cover.png?v=1772318758",
price: "$14.99",
preorder: true
},
{
title: "Connor Dragon Holographic Sticker",
variantId: "49933771964653",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Connor_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Connor Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Cooper-boy": {
displayName: "Cooper",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Cooper Personalized Coloring Experience",
variantId: "49279561236717",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/cooper_final_cover.png?v=1772318760",
price: "$14.99",
preorder: true
},
{
title: "Cooper Dragon Holographic Sticker",
variantId: "49933777535213",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cooper_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Cooper Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Cora-girl": {
displayName: "Cora",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Cora Personalized Coloring Experience",
variantId: "49479133888749",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cora_final_cover.png?v=1772930028",
price: "$14.99",
preorder: true
},
{
title: "Cora Unicorn Holographic Sticker",
variantId: "49933758857453",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cora_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Cora Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Cosmo-boy": {
displayName: "Cosmo",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Cosmo Personalized Coloring Experience",
variantId: "49709346652397",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cosmo_final_cover.png?v=1774104747",
price: "$14.99",
preorder: true
},
{
title: "Cosmo Dragon Holographic Sticker",
variantId: "49933753942253",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cosmo_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Cosmo Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Courtney-girl": {
displayName: "Courtney",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Courtney Personalized Coloring Experience",
variantId: "49279561367789",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Courtney_final_cover.png?v=1773719956",
price: "$14.99",
preorder: true
},
{
title: "Courtney Unicorn Holographic Sticker",
variantId: "49933777502445",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Courtney_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Courtney Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Craig-boy": {
displayName: "Craig",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Craig Personalized Coloring Experience",
variantId: "49709332693229",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Craig_final_cover.png?v=1774104747",
price: "$14.99",
preorder: true
},
{
title: "Craig Dragon Holographic Sticker",
variantId: "49933753975021",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Craig_holographic_sticker.png?v=1779378942",
price: "$4.99",
preorder: false
},
{
title: "Craig Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Crystal-girl": {
displayName: "Crystal",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Crystal Personalized Coloring Experience",
variantId: "49929723216109",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Crystal_final_cover.png?v=1775415513",
price: "$14.99",
preorder: true
},
{
title: "Crystal Unicorn Holographic Sticker",
variantId: "49933745422573",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Crystal_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Crystal Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Charlie-girl": {
displayName: "Charlie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Charlie Personalized Coloring Experience",
variantId: "50078259675373",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Charlie_final_cover_0cf5017e-8539-494f-96d0-cfd92deb1cf4.png?v=1780809444",
price: "$14.99",
preorder: true
},
{
title: "Charlie Unicorn Holographic Sticker",
variantId: "50077630300397",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Charlie_girl_sticker_website.png?v=1780804206",
price: "$4.99",
preorder: false
},
{
title: "Charlie Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Camden-boy": {
displayName: "Camden",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Camden Personalized Coloring Experience",
variantId: "50180870832365",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Camden_final_cover.png?v=1782611298",
price: "$14.99",
preorder: true
},
{
title: "Camden Dragon Holographic Sticker",
variantId: "50180803657965",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Camdenwebsitesticker.png?v=1782610417",
price: "$4.99",
preorder: false
},
{
title: "Camden Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Catalina-girl": {
displayName: "Catalina",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Catalina Personalized Coloring Experience",
variantId: "50245829820653",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Catalina_final_cover.png?v=1783566389",
price: "$14.99",
preorder: true
},
{
title: "Catalina Unicorn Holographic Sticker",
variantId: "50259984810221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Catalina_holographic_sticker.png?v=1783785471",
price: "$4.99",
preorder: false
},
{
title: "Catalina Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Callie-girl": {
displayName: "Callie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Callie Personalized Coloring Experience",
variantId: "50274221818093",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Callie_final_cover.png?v=1783795017",
price: "$14.99",
preorder: true
},
{
title: "Callie Unicorn Holographic Sticker",
variantId: "50274682798317",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Callieholographicsticker.png?v=1783828295",
price: "$4.99",
preorder: false
},
{
title: "Callie Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Colt-boy": {
displayName: "Colt",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Colt Personalized Coloring Experience",
variantId: "50399798100205",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Colt_final_cover.png?v=1785905319",
price: "$14.99",
preorder: true
},
{
title: "Colt Dragon Holographic Sticker",
variantId: "50449512268013",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Colt_holographic_sticker.png?v=1786244663",
price: "$4.99",
preorder: false
},
{
title: "Colt Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Cohen-boy": {
displayName: "Cohen",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Cohen Personalized Coloring Experience",
variantId: "50449693638893",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cohen_final_cover.png?v=1786244941",
price: "$14.99",
preorder: true
},
{
title: "Cohen Dragon Holographic Sticker",
variantId: "50449590681837",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Cohen_holographic_sticker.png?v=1786244663",
price: "$4.99",
preorder: false
},
{
title: "Cohen Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Crew-boy": {
displayName: "Crew",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Crew Personalized Coloring Experience",
variantId: "50457726779629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Crew_final_cover.png?v=1786406747",
price: "$14.99",
preorder: true
},
{
title: "Crew Dragon Holographic Sticker",
variantId: "50457694241005",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Crew_holographic_sticker.png?v=1786406786",
price: "$4.99",
preorder: false
},
{
title: "Crew Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Camille-girl": {
displayName: "Camille",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Camille Personalized Coloring Experience",
variantId: "50643940606189",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Camille_final_cover.png?v=1788490621",
price: "$14.99",
preorder: true
},
{
title: "Camille Unicorn Holographic Sticker",
variantId: "50643954663661",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Camille_holographic_sticker.png?v=1788490590",
price: "$4.99",
preorder: false
},
{
title: "Camille Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 








};